import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=1a50e2e4&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=ts"
export * from "./FormCard.vue?vue&type=script&lang=ts"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=1a50e2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50e2e4",
  null
  
)

export default component.exports